import { render, staticRenderFns } from "./Cooking.vue?vue&type=template&id=19ee14fe&scoped=true&"
import script from "./Cooking.vue?vue&type=script&lang=js&"
export * from "./Cooking.vue?vue&type=script&lang=js&"
import style0 from "./Cooking.vue?vue&type=style&index=0&id=19ee14fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ee14fe",
  null
  
)

export default component.exports